function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35B38"
    },
    d: "M129.075,282.623H65.923c-30.775,0-55.723-24.948-55.723-55.722l0,0 c0-30.775,24.948-55.723,55.723-55.723h63.152C129.075,171.177,129.075,282.623,129.075,282.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAD61"
    },
    d: "M437.409,397.784V56.016c0-17.781,14.415-32.196,32.196-32.196l0,0 c17.781,0,32.196,14.415,32.196,32.196v341.768c0,17.781-14.415,32.196-32.196,32.196l0,0 C451.824,429.98,437.409,415.566,437.409,397.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M153.714,457.772c2.778,17.514,17.878,30.408,35.612,30.408h38.386V333.16l-98.468-29.667 L153.714,457.772z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE6B8"
    },
    points: "437.409,386.64 437.409,67.161 129.075,150.359 129.075,303.442 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M469.606,13.621c-23.377,0-42.395,19.018-42.395,42.395v3.332l-300.793,81.163 c-4.45,1.2-7.542,5.237-7.542,9.847v10.62H65.923C29.573,160.978,0,190.551,0,226.901s29.573,65.923,65.923,65.923h52.953v10.619 c0,1.162,0.197,2.286,0.562,3.338L143.64,459.37h0.001c3.586,22.603,22.799,39.009,45.684,39.009h38.386 c5.632,0,10.199-4.566,10.199-10.199V343.374l189.3,51.079v3.332c0,23.377,19.018,42.395,42.395,42.395S512,421.161,512,397.784 V56.016C512,32.639,492.983,13.621,469.606,13.621z M65.923,272.425c-25.102,0-45.524-20.423-45.524-45.525 c0-25.101,20.422-45.523,45.524-45.523h52.953v17.988H89.45c-5.632,0-10.199,4.566-10.199,10.199 c0,5.633,4.567,10.199,10.199,10.199h29.426v14.274H89.45c-5.632,0-10.199,4.566-10.199,10.199s4.567,10.199,10.199,10.199h29.426 v17.989H65.923z M217.512,337.869v140.112h-28.187c-12.793,0-23.534-9.171-25.539-21.807h0.001l-21.925-138.228L217.512,337.869z  M139.274,158.17l287.937-77.693v292.847L139.274,295.63L139.274,158.17L139.274,158.17z M447.608,56.016 c0-12.129,9.868-21.997,21.997-21.997c12.129,0,21.996,9.868,21.996,21.997v341.768c0,12.129-9.868,21.997-21.996,21.997 c-12.13,0-21.997-9.868-21.997-21.997V56.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M406.545,333.351l-8.48-2.289c-5.442-1.466-11.037,1.751-12.504,7.189 c-1.468,5.439,1.751,11.037,7.189,12.504l8.48,2.289c0.89,0.24,1.784,0.355,2.663,0.355c4.496,0,8.613-2.997,9.84-7.544 C415.203,340.417,411.985,334.818,406.545,333.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M364.964,322.131l-198.419-53.54c-5.442-1.467-11.037,1.752-12.504,7.19 c-1.468,5.438,1.751,11.037,7.189,12.504l198.419,53.54c0.89,0.24,1.784,0.355,2.663,0.355c4.496,0,8.613-2.996,9.84-7.544 C373.621,329.197,370.402,323.598,364.964,322.131z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneIcon);
export default __webpack_public_path__ + "static/media/megaphone-icon.8520d128a84085a9572b79b3254b4f9a.svg";
export { ForwardRef as ReactComponent };